export default "__VITE_ASSET__255e3169__"